export default __webpack_public_path__ + "static/media/logo_main.5771bfe8.png";